import { NgModule } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxsModule } from '@ngxs/store';
import { TestPatientsComponent } from './test-patients.component';
import { TestPatientsRoutingModule } from './test-patients-routing.module';
import { TestPatientsState } from '../core/store/test-patients/test-patients.state';
import { SharedModule } from '../shared/shared.module';
import { FormatDatePipe, FormatCurrencyPipe, FormatBooleanPipe } from 'src/app/core/utils/pipes';
import { TestRegistrationComponent } from './test-registration/test-registration.component';
import { TableModule } from 'primeng/table';
import { TestAgentComponent } from './test-agent/test-agent.component';

@NgModule({
  declarations: [TestPatientsComponent, TestRegistrationComponent, TestAgentComponent],
  imports: [
    AvatarModule,
    ButtonModule,
    CardModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TestPatientsRoutingModule,
    TableModule,
  ],
  providers: [FormatBooleanPipe, FormatCurrencyPipe, FormatDatePipe],
})
export class TestPatientsModule {}
